export default __webpack_public_path__ + "static/media/tailwind.017e1e30.svg";